<template>
  <div class="person">
    <div class="top-box">
      <div class="top_info"
           style="border:undefined solid red;">
        <div class="info">
          <section v-if="user_id"
                   class="login">
            <div class="avatar"
                 @click="onInfo">
              <img :src="userInfo.avatar || headerImg" />
            </div>
            <div class="extra">
              <p class="name"
                 @click="onInfo">{{userInfo.nickname}}</p>
              <router-link :to="{ name: 'Sign' }">
                <p class="signIn">签到领积分</p>
              </router-link>
              <!-- <p class="vip"
                 @click.stop="onVip"
                 v-if="config.switch_vip_module != '0'">
                <span>{{userInfo.is_vip ? '续费会员' : '开通会员'}}></span>
              </p> -->
            </div>
          </section>
          <section v-else
                   class="no-login"
                   @click="onLogin">
            <div class="avatar">
              <img src="~@/assets/images/avatar.png" />
            </div>
            <p>登录/注册</p>
          </section>
        </div>
        <div class="mine">
          <div v-for="(item, index) in mineList"
               :key="index"
               class="mine-item"
               :class="item.style"
               @click="onMineItem(item)">
            <p class="count">{{item.count}}</p>
            <p class="name">{{item.name}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <ul v-for="(menuItem, index) in menusList"
          :key="index">
        <p class="menuTitle">{{menuItem.title}}</p>
        <div class="lis">
          <li v-for="(item, index) in menuItem.child"
              :key="index"
              @click="onMenuItem(item)"
              :class="item.style || ''"
              v-show="item.hidden != '0'">
            <div class="icon-menu"
                 :style="{ width: item.width, height: item.height }">
              <img :src="item.icon" />
            </div>
            <span class="menu_name">{{item.name}}</span>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "person",
  data () {
    return {
      userInfo: {},
      headerImg: require("@/assets/images/user_Headportrait.png"),
      newMessage: false,
      user_id: "",
      mineList: [
        {
          count: 0,
          name: "账户余额",
          style: "my-study",
          url: "MyAccount"
        },
        {
          count: 0,
          name: "当前积分",
          style: "my-plan",
          url: "IntegralDetail"
        },
      ]
    };
  },
  created () {
    this.user_id = localStorage.user_id;
    if (this.user_id) {
      this.requestUserInfo();
    }
    window.scrollTo(0, 0);
  },
  computed: {
    menusList () {
      let arr = [{
        title: '我的练习',
        child: [
          {
            name: "我的练习",
            width: '19px',
            height: '19px',
            icon: require("@/assets/images/icon_exercise.png"),
            url: "Exercise",
            query: { type: 'exam/exercise/my' }
          },
          {
            name: "我的考试",
            width: '17px',
            height: '20px',
            icon: require("@/assets/images/icon_exam.png"),
            url: "Exam",
            query: { type: 'exam/my' }
            // hidden: this.config.homework_module.is_open
          },
          {
            name: "我的打卡",
            width: '17px',
            height: '21px',
            icon: require("@/assets/images/icon_checkIn.png"),
            url: "MyCheckIn"
          },
          {
            name: "我的作业",
            width: '17px',
            height: '19px',
            icon: require("@/assets/images/icon_homework.png"),
            url: "Homework",
          },
        ]
      }, {
        title: '学习记录',
        child: [
          {
            name: "学习轨迹",
            width: '20px',
            height: '20px',
            icon: require("@/assets/images/icon_path.png"),
            url: "LearningPath",
          },
          {
            name: "错题本",
            width: '18px',
            height: '21px',
            icon: require("@/assets/images/icon_error_list.png"),
            url: "ErrorQues",
          },
          {
            name: "习题收藏",
            width: '21px',
            height: '21px',
            icon: require("@/assets/images/icon_myCollect.png"),
            url: "QuesCollect",
          },
          {
            name: "我的问答",
            width: '20px',
            height: '20px',
            icon: require("@/assets/images/icon_myQus@2x.png"),
            url: "MyAskList",
          },
          // {
          //   name: "我的下载",
          //   width: '24px',
          //   height: '18px',
          //   icon: require("@/assets/images/icon_download.png"),
          //   url: "Order",
          // },
          {
            name: "我的收藏",
            width: '23px',
            height: '22px',
            icon: require("@/assets/images/icon_attention.png"),
            url: "Collect",
          }
        ]
      },
      {
        title: '账号信息',
        child: [
          {
            name: "课程订单",
            width: '18px',
            height: '20px',
            icon: require("@/assets/images/icon_course_order.png"),
            url: "Order",
            query: { order_type: 2 }
          },
          {
            name: "图书订单",
            width: '18px',
            height: '20px',
            icon: require("@/assets/images/icon_book_icon.png"),
            url: "Order",
            query: { order_type: 4 }
          },
          {
            name: "练习订单",
            width: '18px',
            height: '20px',
            icon: require("@/assets/images/icon_order.png"),
            url: "Order",
            query: { order_type: 5 }
          },
          {
            name: "模考订单",
            width: '18px',
            height: '20px',
            icon: require("@/assets/images/icon_exam_order.png"),
            url: "Order",
            query: { order_type: 6 }
          },
          {
            name: "地址管理",
            width: '20px',
            height: '22px',
            icon: require("@/assets/images/icon_address.png"),
            url: "Address",
            hidden: this.config.switch_study_module
          },
          {
            name: "优惠券",
            width: '25px',
            height: '17px',
            icon: require("@/assets/images/icon_quan.png"),
            url: "Coupon"
          },
          {
            name: "学习卡",
            width: '21px',
            height: '17px',
            icon: require("@/assets/images/icon_study_card.png"),
            url: "Card",
            hidden: this.config.switch_study_module
          },
          // {
          //   name: "我的金币",
          //   width: '21px',
          //   height: '17px',
          //   icon: require("@/assets/images/icon_gold_coin.png"),
          //   url: "MyCurrency",
          // }
        ]
      },
      {
        title: '自助服务',
        child: [
          {
            name: "我的消息",
            width: '19px',
            height: '21px',
            icon: require("@/assets/images/icon_message.png"),
            url: "Message",
            style: {
              "has-message": this.newMessage
            }
          },
          {
            name: "在线服务",
            width: '20px',
            height: '22px',
            icon: require("@/assets/images/icon_service.png"),
            url: "OnlineService"
          },
          {
            name: "关于我们",
            width: '22px',
            height: '18px',
            icon: require("@/assets/images/icon_aboutUs.png"),
            url: "About"
          },
          {
            name: "意见反馈",
            width: '20px',
            height: '21px',
            icon: require("@/assets/images/icon_feedback.png"),
            url: "Feedback"
          },
          {
            name: "设置",
            width: '19px',
            height: '19px',
            icon: require("@/assets/images/icon_setting.png"),
            url: "Options"
          }
        ]
      }
      ];
      return arr;
    },
    config () {
      return this.$store.state.config;
    },

    point_name () {
      if (this.$store.state.config) {
        return this.$store.state.config.point_info.point_name
      } else {
        return '';
      };
    },
  },
  methods: {
    // on event
    onLogin () {
      this.turnPage("SmsLogin");
    },
    onMineItem (item) {
      if (!item.url) return;
      this.turnPage(item.url);
    },
    onInfo () {
      this.turnPage("Info");
    },
    onVip () {
      this.turnPage("Vip");
    },
    onMenuItem (item) {
      if (item.url == "Homework") {
        this.$store.commit("IS_RESET_STATE", 1);
      }
      this.turnPage(item.url, item.query);
    },
    // other
    turnPage (name, query) {
      if (!this.user_id) {
        // 未登录 统一推到验证码登录页面
        this.$router.push({
          name: "SmsLogin"
        });
        return;
      }
      this.$router.push({
        name,
        query
      });
    },
    // rquest
    requestUserInfo () {
      this.$http.get("/api/app/userInfo").then(data => {
        this.userInfo = data;
        this.requestMessage();
        this.requestCount();
      });
    },
    requestMessage () {
      this.$http.post("/api/app/message/classifyMessage").then(data => {
        for (const i of data) {
          if (i.is_read == 0) {
            this.newMessage = true;
            break;
          }
        }
      });
    },
    requestCount () {
      this.$http.get("/api/app/getUCenterInfo").then(data => {
        this.mineList[0].count = data.balance / 100;
        this.mineList[1].count = data.integral;
        // this.mineList[2].count = data.integral;
      });
    }
  }
};
</script>
<style scoped lang="scss">
.person {
  overflow: hidden;
  padding-bottom: 150px;
  @extend %default-bg;
  background-color: #fff;
}
.top-box {
  height: 460px;
  background: url("~@/assets/theme-img/user_bg2.png") no-repeat top center;
  background-size: 100%;
  background-color: #fff;
  position: relative;
  .top_info {
    position: absolute;
    bottom: 0;
    width: 690px;
    height: 333px;
    box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    left: 30px;
    background-color: #fff;
    right: 30px;
  }
  .info {
    // overflow: hidden; //触发BFC
    .login {
      overflow: hidden; //触发BFC
      position: relative;
      .avatar {
        float: left;
        margin: 30px 20px 0 30px;
      }
      .extra {
        margin-top: 40px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100px;
        .name {
          font-size: 32px;
          color: #333;
          font-weight: 500;
        }
        .signIn {
          margin-top: 21px;
          font-size: 24px;
          color: $theme_color;
        }
        .vip {
          margin-top: 30px;
          display: inline-block;
          width: 186px;
          height: 48px;
          border-radius: 20px;
          background: url("~@/assets/images/icon-vip.png") no-repeat;
          background-position: 15px center;
          background-size: 25px;
          background-color: rgba(0, 0, 0, 0.2);
          font-size: 24px;
          color: #fff;
          line-height: 48px;
          span {
            margin-left: 50px;
          }
        }
      }
      &:after {
        content: "";
        display: block;
        border-top: 3px solid #fff;
        border-right: 3px solid #fff;
        width: 30px;
        height: 30px;
        position: absolute;
        top: 50%;
        right: 40px;
        transform: translateY(-50%) rotate(45deg);
      }
    }
    .no-login {
      // margin-top: 106px;
      @extend %flex-center;
      justify-content: flex-start;
      align-items: center;
      // flex-direction: column;
      p {
        font-size: 32px;
        color: #333333;
      }
    }
    .avatar {
      width: 126px;
      height: 126px;
      // background-color: #bdcdf1;
      border-radius: 50%;
      @extend %flex-center;
      img {
        width: 118px;
        height: 118px;
        border-radius: 50%;
      }
    }
  }

  .mine {
    display: flex;
    justify-content: space-between;
    width: 100%;
    .mine-item {
      width: 50%;
      // height: 230px;
      text-align: center;
      position: relative;
      .count {
        margin-top: 46px;
        font-size: 48px;
        color: #333;
        margin-bottom: 23px;
      }
      .name {
        font-size: 28px;
        color: #595959;
        margin-bottom: 12px;
      }
      &::after {
        content: "";
        display: block;
        width: 1px;
        height: 48px;
        background-color: #f5f5f5;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
      &:last-child::after {
        display: none;
      }
    }
  }
}

.bottom-box {
  .menuTitle {
    color: #333;
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 30px;
  }
  ul {
    background-color: #fff;
    margin: 30px 0;
    padding: 10px 30px;
    .lis {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 20px;
      // border-bottom: 1px solid #eeeeee;
      .icon-menu {
        width: 38px;
        height: 40px !important;
        position: relative;
        margin: 23px 0;
        img {
          position: absolute;
          bottom: 0;
          width: 100%;
        }
      }
      .menu_name {
        height: 42px;
        line-height: 42px;
      }
    }
    li {
      position: relative;
      font-size: 28px;
      color: #595959;
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 10px;
    }
  }
}
</style>
